import z from "zod";

export const CustomerInfoDBScheme = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
  phone: z.string().optional(),
  note: z.string().optional(),

  deliveryAddress: z
    .object({
      street: z.string().optional(),
      postalcode: z.string().optional(),
      city: z.string().optional(),
      country: z.string().optional(),
    })
    .optional(),
});

export type CustomerInfo = z.infer<typeof CustomerInfoDBScheme>;
